<script lang="ts">
  import { onMount } from "svelte";

  export let text: string;
  export let customClass: string = "";
  export let imgClass: string = "";
  let lines: string[] = [];
  let tooltipVisible = false;
  let tooltipStyle = "";

  let buttonElement: HTMLButtonElement;
  let tooltipElement: HTMLDivElement;

  $: lines = text.split("\n"); // Reactively split the text into lines

  const imgClicked = () => {
    tooltipVisible = !tooltipVisible;
    updateTooltipPosition();
  };

  const updateTooltipPosition = () => {
    const { top, left, width } = buttonElement.getBoundingClientRect();
    tooltipStyle = `top: ${top + window.scrollY - 30}px; left: ${
      left + width / 2
    }px; transform: translateX(-50%);`;
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      tooltipVisible && !buttonElement.contains(event.target as Node) &&
      !tooltipElement.contains(event.target as Node)
    ) {
      tooltipVisible = false;
    }
  };

  onMount(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });
</script>

<div class={customClass}>
  <button on:click={imgClicked} class="h-6 relative" bind:this={buttonElement}>
    <img
      src="/icons/tooltip-static.svg"
      class="input-image {imgClass}"
      alt="Tooltip Icon"
    />
  </button>
  {#if tooltipVisible}
    <div
      class="absolute bg-[#062427] text-white p-2 rounded whitespace-normal z-10 shadow-lg"
      style={tooltipStyle}
      role="tooltip"
      aria-hidden={!tooltipVisible}
      bind:this={tooltipElement}
    >
      {#each lines as line}
        <div>{line}</div>
      {/each}
    </div>
  {/if}
</div>
